import { partnerAsset } from "../shared/assets";

export const asset = (path: string): string => partnerAsset("mad-monkey", path);
